module.exports = __webpack_public_path__ + "static/media/599.7554(20).24ad4c37.pdf";